import { deleteLineItem } from "@lib/data/cart"
import { Loader2, Trash2 } from "lucide-react"
import { useState } from "react"

const DeleteButton = ({
  id,
  children,
  className,
}: {
  id: string
  children?: React.ReactNode
  className?: string
}) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async (id: string) => {
    setIsDeleting(true)
    await deleteLineItem(id)
    setIsDeleting(false)
  }

  return (
    <div
      className={`flex items-center justify-between text-sm ${className || ""}`}
    >
      <button
        className={`flex gap-x-1 items-center cursor-pointer transition-colors ${
          children
            ? "text-gray-500 underline hover:text-gray-900"
            : "text-gray-500 hover:text-brand-accent"
        }`}
        onClick={() => handleDelete(id)}
      >
        {isDeleting ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : children ? null : (
          <Trash2 className="h-4 w-4" />
        )}
        {children && (
          <span>{isDeleting ? "Removing..." : children}</span>
        )}
      </button>
    </div>
  )
}

export default DeleteButton
